import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { GetAllTimeStorageUsageRequest } from "../proto/api_pb";
import { RpcError } from "grpc-web";

export const getStorageUsage = async (
  userId: string,
  accessToken: string
): Promise<number | RpcError | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetAllTimeStorageUsageRequest();
    request.setUserId(userId);
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<number | RpcError>((resolve, reject) => {
          ommuseClient.getAllTimeStorageUsage(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response.getStorageUsage());
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};
